import { AddIcon, RemoveIcon } from '@diligentcorp/atlas-react-icons';
import {
  FormLabel,
  IconButton,
  InputAdornment,
  TextFieldProps as MuiTextFieldProps,
  Stack,
} from '@mui/material';
import { StyledTextField, TextFieldExtraProps } from '../text-field';

function onlyNumbers(inputString: string): boolean {
  return /^-?\d+$/.test(inputString);
}

export type NumberFieldProps = MuiTextFieldProps &
  TextFieldExtraProps & {
    handleIncrement: (value: number) => void;
    handleDecrement: (value: number) => void;
  };

export function NumberField({
  name,
  label,
  labelInfo,
  required,
  handleIncrement,
  handleDecrement,
  value,
  ...props
}: NumberFieldProps) {
  const { InputLabelProps, ...rest } = props;

  const handleNumberChanged = (fn: (value: number) => void) => {
    const stringValue = value as string;
    if (onlyNumbers(stringValue)) {
      fn?.(parseInt(stringValue, 10));
    }
  };

  const inputReadonly = rest.InputProps?.readOnly;

  return (
    <Stack width='100%'>
      {label && (
        <FormLabel
          required={required}
          id={`${name}-label`}
          {...InputLabelProps}
        >
          {label}
        </FormLabel>
      )}

      {labelInfo && <FormLabel color='info'>{labelInfo}</FormLabel>}

      <StyledTextField
        {...rest}
        value={value}
        data-aria-labelledby={`${name}-label`}
        type='text'
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                onClick={() => handleNumberChanged(handleDecrement)}
                aria-label='decrease number'
                disabled={inputReadonly}
              >
                <RemoveIcon />
              </IconButton>
              <IconButton
                onClick={() => handleNumberChanged(handleIncrement)}
                aria-label='increase number'
                disabled={inputReadonly}
              >
                <AddIcon />
              </IconButton>
            </InputAdornment>
          ),
          readOnly: inputReadonly,
        }}
      />
    </Stack>
  );
}
